export const VERSION_PATH = '/version.json';
export const BUNDLE_SHA_META = 'specra-bundle-sha';
/** How often a visible tab asks dock-one which sha it is serving. */ export const BASE_CHECK_MS = 5 * 60 * 1000;
/** Ceiling after repeated failures — still minutes, never a storm. */ export const MAX_CHECK_MS = 30 * 60 * 1000;
/** Focus and visibilitychange often fire together; collapse them. */ export const MIN_CHECK_GAP_MS = 2000;
const SHA = /^[0-9a-f]{7,64}$/;
export function normalizeBundleSha(value) {
    return value.trim().toLowerCase();
}
export function isBundleSha(value) {
    return SHA.test(value);
}
/** The sha baked into the shell this tab loaded. Empty in webpack-dev. */ export function readOwnBundleSha(doc = document) {
    const content = doc.querySelector(`meta[name="${BUNDLE_SHA_META}"]`)?.getAttribute('content') ?? '';
    const sha = normalizeBundleSha(content);
    return isBundleSha(sha) ? sha : '';
}
export function parseServedVersion(payload) {
    if (!payload || typeof payload !== 'object') {
        return null;
    }
    const sha = payload.sha;
    if (typeof sha !== 'string') {
        return null;
    }
    const normalized = normalizeBundleSha(sha);
    if (normalized === '') {
        return '';
    }
    return isBundleSha(normalized) ? normalized : null;
}
export function isNewerBundle(ownSha, servedSha) {
    return ownSha !== '' && servedSha !== '' && ownSha !== servedSha;
}
export function nextCheckDelay(consecutiveFailures, baseMs = BASE_CHECK_MS, maxMs = MAX_CHECK_MS) {
    const shift = Math.min(Math.max(consecutiveFailures, 0), 8);
    return Math.min(baseMs * 2 ** shift, maxMs);
}
function isTextEditable(el) {
    if (!el || !(el instanceof HTMLElement)) {
        return false;
    }
    if (el.isContentEditable) {
        return true;
    }
    if (el.tagName === 'TEXTAREA') {
        return true;
    }
    if (el.tagName === 'INPUT') {
        const type = el.type;
        return ![
            'button',
            'submit',
            'reset',
            'checkbox',
            'radio',
            'hidden',
            'file'
        ].includes(type);
    }
    return false;
}
function hasUnsentDraft(doc) {
    for (const node of doc.querySelectorAll('textarea, [contenteditable="true"]')){
        if (node instanceof HTMLTextAreaElement && node.value.trim() !== '') {
            return true;
        }
        if (node instanceof HTMLElement && node.isContentEditable && (node.textContent ?? '').trim() !== '') {
            return true;
        }
    }
    return false;
}
function hasOpenDialog(doc) {
    for (const dialog of doc.querySelectorAll('[role="dialog"]')){
        if (!(dialog instanceof HTMLElement)) {
            continue;
        }
        if (dialog.hidden || dialog.getAttribute('aria-hidden') === 'true') {
            continue;
        }
        if (dialog.getAttribute('data-state') === 'closed') {
            continue;
        }
        return true;
    }
    return false;
}
/**
 * Auto-reload is unsafe while the user is mid-edit. The banner's Reload
 * button is a deliberate click and does not consult this.
 */ export function isReloadBlocked(doc = document) {
    if (hasOpenDialog(doc)) {
        return true;
    }
    if (isTextEditable(doc.activeElement)) {
        return true;
    }
    return hasUnsentDraft(doc);
}
